export default class UserFriendlyException extends Error
{
	private userFriendlyMessage: string = 'An unexpected error occurred. Please try again later.';

	public constructor(message: string, userFriendlyMessage: string)
	{
		super(message);
		this.name = 'UserFriendlyException';
		this.userFriendlyMessage = userFriendlyMessage;
	}

	public getUserFriendlyMessage(): string
	{
		return this.userFriendlyMessage;
	}
}
